import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaMicrophone, FaStop } from 'react-icons/fa';
import { postDataUser } from '../ApiServices/ApiService';


// This component provides a mic button that records transcribes and provides the transcribed text to the parent component. 
// All styles in components are customizeable as props. 
// Provide a callback function "onTranscribeHandle" to determine what to do with transcribed text.
/* Example Usage:
    <MicRecordAndTranscribe
      buttonStyle={{marginTop: '5px'}}
      recordText=''
      isRecordingText=''
      onTranscribeHandle={handleTranscriptionComplete}
    />
*/
const MicRecordAndTranscribe = (
  // Customizable props
  { buttonStyle = { padding: '10px 40px' },
    isRecordingText = 'You are speaking',
    isRecordingStyle = { color: 'green' },
    recordText = 'Click Mic to Speak',
    recordStyle = { color: 'red' },
    divStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    onTranscribeHandle
  }
) => {
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);

  const handleMicClick = () => {
    if (!isRecording) {
      startRecording();
    } else {
      stopRecording();
    }
    setIsRecording((prevState) => !prevState);
  };

  const convertBlobToText = async (blobAudio) => {
    const payload = {
      "op": "simple_transcription",
      "audio_data": blobAudio
    };

    postDataUser('candidate_audio_transcription', payload)
      .then(resp => resp.json())
      .then(respData => {
        if (respData.statusCode === 200) {
          onTranscribeHandle(respData.dataJ.transcribed_text); // Callback
          console.log('Transcription successful:', respData.dataJ.transcribed_text);
        } else {
          // Handle any other statusCode that isn't a success
          console.error('Error during transcription:', respData.info || 'Error during transcription...');
          window.alert('Something went wrong. Please try again.');
        }
      })
      .catch((error) => {
        // Handle network errors
        console.error('Network Error:', error);
        window.alert('Network Error. Please try again.');
      });
  }

  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const recorder = new MediaRecorder(stream);
        recorder.start();

        const audioChunks = [];
        recorder.addEventListener('dataavailable', (event) => {
          audioChunks.push(event.data);
        });

        recorder.addEventListener('stop', () => {
          const audioBlob = new Blob(audioChunks);

          // Convert Blob to base64
          const reader = new FileReader();
          reader.readAsDataURL(audioBlob);
          reader.onloadend = () => {
            const base64Data = reader.result.split(',')[1]; // Extract base64 data from result
            convertBlobToText(base64Data);
          };
        });

        setMediaRecorder(recorder);
      })
      .catch((error) => {
        console.error('Error accessing microphone:', error);
        window.alert('Error accessing microphone. Please check your settings.');
      });
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setMediaRecorder(null);
    }
  };

  return (
    <div style={divStyle}>
      {isRecording ? (
        <Button
          variant="outline-success"
          style={buttonStyle}
          onClick={handleMicClick}
        >
          <FaStop className="icon qes-icon-size" />
        </Button>
      ) : (
        <Button
          variant="outline-danger"
          style={buttonStyle}
          onClick={handleMicClick}
        >
          <FaMicrophone className="icon qes-icon-size" />
        </Button>
      )}
      {isRecording ? (
        <p style={isRecordingStyle}>{isRecordingText}</p>
      ) : (
        <div className="text-center mt-1 speak-text">
          <p style={recordStyle}>{recordText}</p>
        </div>
      )}
    </div>
  );
};

export default MicRecordAndTranscribe;
// Transcription powered by lambda named "air_generate_jd"